export const shiki = {
  id: "shiki",
  link: "/#/recipes/recipes/shiki",
  name: "Shiki",
  cuisine: "Horneater",
  summary: "Roasted rice tea",
  inspiration: "Mugicha",
  quantity: "1 gallon",
  time: "90 minutes, plus additional chilling time",
  notes:
    "We know a few things about shiki from Oathbringer chapter 37. It's brownish in color, served chilled, and implied to not be alcoholic. It was unpopular with people not familiar with it, unless they were hot and exhausted. This all sounded to me exactly like mugicha. Mugicha is a Japanese barley tea, known for tasting like 'burnt water.' There's something about it, though, where if you're hot and thirsty, it tastes amazing. The Alethi wouldn't have access to barley, so instead I made something similar with roasted brown rice. Cayenne pepper optionally serves as the lazbo that Huio added.",
  quotes:
    "He stirred the shiki, a brownish Horneater drink that Lunamor had chilled overnight in metal bins (Oathbringer ch 37)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/shiki-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "rice",
          display: "1/2 cup brown rice"
        },
        {
          item: "water",
          display: "10 cups water"
        },
        {
          item: "hotPeppers",
          display: "Cayenne powder to taste (optional)"
        }
      ]
    }
  ],
  steps: [
    "Preheat the oven to 350 degrees Fahrenheit. Spread the rice on a baking sheet in a single layer, then roast for 40 minutes, shaking or stirring the pan every 10 minutes, until the rice is all dark brown.",
    "Bring the water to boil in a pot. Add the rice, then reduce the heat and simmer for 20 minutes. Turn off the heat and let sit for 7 more minutes.",
    "Strain the liquid, keeping the liquid and discarding the rice. Chill in the refrigerator. Serve chilled, optionally with a pinch of cayenne powder added to each cup."
  ]
}
